import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dlgHost]',
    standalone: false
})
export class DialogHostDirective {
  public constructor(public viewContainerRef: ViewContainerRef) {}
}
